import i18n from '@/_helpers/i18n';

const generalErrors = ["error", "paymentrequired", "errordata", "outofservice"];

// Cada navegador redacta distinto el fallo de red: Chrome dice "Failed to
// fetch", Firefox "NetworkError when attempting to fetch resource" y Safari
// "Load failed". Detectarlo por el texto de Chrome dejaba fuera a los demas y
// el mensaje terminaba usandose como clave de traduccion, de ahi el
// "lang.login.error.TypeError: ..." que veia el usuario en Firefox.
const NETWORK_ERROR = /Failed to fetch|NetworkError|Load failed|Network request failed|connection appears to be offline/i;

// fetch() rechaza con TypeError ante un fallo de red en los tres navegadores,
// asi que la clase del error es mas fiable que su texto.
export function isNetworkError(error) {
    if (typeof TypeError !== 'undefined' && error instanceof TypeError) {
        return true;
    }
    const text = error && error.message ? error.message : error;
    return NETWORK_ERROR.test(String(text));
}

// El cuerpo de una respuesta de error del servidor no siempre es JSON (una 500
// devuelve HTML) y el JSON.parse de los servicios lanza SyntaxError. No es un
// fallo de red: el servidor contesto, pero con algo que no sabemos leer.
function isBadServerResponse(error) {
    return error instanceof SyntaxError;
}

// i18n.t() devuelve la propia clave cuando no existe la traduccion, asi que hay
// que preguntar antes con te() o se le acaba mostrando la clave al usuario.
function translate(key) {
    const fullKey = 'lang.' + key;
    if (i18n.te(fullKey) || i18n.te(fullKey, 'en')) {
        return i18n.t(fullKey);
    }
    return null;
}

// Nunca devuelve una clave: si no hay traduccion cae a un texto generico.
function messageFor(key, fallbackKey) {
    return translate(key)
        || (fallbackKey ? translate(fallbackKey) : null)
        || translate('general.error')
        || 'Error';
}

// Deja en consola la llamada que fallo. Antes no quedaba ningun rastro de cual
// era, que es parte de por que el incidente del 14-15/09 costo tanto diagnosticar.
function logFailure(label, { url, method, message }) {
    try {
        console.error('[Oliverlist] ' + label, {
            url: url || 'no informada',
            method: method || 'no informado',
            detail: String(message)
        });
    } catch (e) {
        // el log nunca puede romper la UI
    }
}

export const alert = {
    namespaced: true,
    state: {
        type: null,
        message: null
    },
    actions: {
        success({ commit }, message) {
            commit('success', message);
        },
        error({ commit }, message) {
            commit('error', message);
        },
        newError({ commit }, { message, section, fallbackKey, url, method }) {
            if (isNetworkError(message)) {
                logFailure('fallo de red', { url, method, message });
                commit('error', messageFor('general.networkerror'));
                return;
            }

            if (isBadServerResponse(message)) {
                logFailure('respuesta ilegible del servidor', { url, method, message });
                commit('error', messageFor('general.servererror'));
                return;
            }

            const raw = String(message);

            if (generalErrors.includes(raw)) {
                commit('error', messageFor('general.' + raw));
            } else if (section !== undefined) {
                commit('error', messageFor(section + '.error.' + raw, fallbackKey));
            } else {
                commit('error', raw);
            }
        },
        clear({ commit }) {
            commit('clear');
        }
    },
    mutations: {
        success(state, message) {
            state.type = 'alert-success';
            state.message = message;
        },
        error(state, message) {
            state.type = 'alert-danger';
            state.message = message;
        },
        clear(state) {
            state.type = null;
            state.message = null;
        }
    }
}
